import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { RegistrationPaths } from '@gipi-paths/registration.paths';
import { AbstractCrudService, FilterDTO } from '@gipisistemas/ng-core';
import { RegistrationSocialNetworkType } from '../models/social-network-type.model';

@Injectable({ providedIn: 'root' })
export class RegistrationSocialNetworkTypeService extends AbstractCrudService<RegistrationSocialNetworkType, FilterDTO> {

    constructor(http: HttpClient) {
        super(RegistrationPaths.socialNetworkType, http);
    }

}
